import { useContext } from 'react';
import { OperationContext, OperationContextValue } from '../context/OperationProvider';

export const useOperation = (): OperationContextValue => {
  const context = useContext(OperationContext);

  if (!context) {
    throw new Error('useOperation must be used within an OperationProvider');
  }

  return context;
};

export default useOperation;
